import Hero from "./Components/Hero";
import Team from "./Components/Team";

import Footer from "./Components/Footer";

function About() {
  return (
    <div>
      <Hero />
      <Team />
      <Footer />
    </div>
  );
}

export default About;
